export const EXCHANGE_READ_REQUESTED = 'exchange read requested'
export const EXCHANGE_READ_SUCCEEDED = 'exchange read succeeded'
export const EXCHANGE_READ_FAILED = 'exchange read failed'

export const EXCHANGE_CREATE_REQUESTED = 'create new option in exchange requested'
export const EXCHANGE_CREATE_SUCCEEDED = 'create new option in exchange succeeded'
export const EXCHANGE_CREATE_FAILED = 'create new option in exchange failed'

export const EXCHANGE_DELETE_REQUESTED = 'exchange delete requested'
export const EXCHANGE_DELETE_SUCCEEDED = 'exchange delete succeeded'
export const EXCHANGE_DELETE_FAILED = 'exchange delete failed'

export const EXCHANGE_UPDATE_REQUESTED = 'update an attribute in a option requested'
export const EXCHANGE_UPDATE_SUCCEEDED = 'update an attribute in a option suceeded'
export const EXCHANGE_UPDATE_FAILED = 'update an attribute in a option failed'

export const EXCHANGE_UPDATES_REQUESTED = 'update mass options requested'
export const EXCHANGE_UPDATES_SUCCEEDED = 'update mass options suceeded'
export const EXCHANGE_UPDATES_FAILED = 'update mass options failed'

export const exchangeReadRequested = () => ({
    type: EXCHANGE_READ_REQUESTED
})
export const exchangeReadSucceeced = (payload) => ({
    type: EXCHANGE_READ_SUCCEEDED,
    payload: payload
})
export const exchangeReadFailed = (err, res) => ({
     type: EXCHANGE_READ_FAILED,
     error: err,
     response: res
})

export const exchangeCreateRequested = ()=> ({
    type: EXCHANGE_CREATE_REQUESTED
})
export const exchangeCreateSucceeded = (payload) => ({
    type: EXCHANGE_CREATE_SUCCEEDED,
    payload: payload
})
export const exchangeCreateFailed = (err, res) => ({
    type: EXCHANGE_CREATE_FAILED,
    error: err,
    response: res
})

export const exchangeDeleteRequested = ()=> ({
    type: EXCHANGE_DELETE_REQUESTED
})
export const exchangeDeleteSucceeded = (payload) => ({
    type: EXCHANGE_DELETE_SUCCEEDED,
    payload: payload
})
export const exchangeDeleteFailed = (err, res) => ({
    type: EXCHANGE_DELETE_FAILED,
    error: err,
    response: res
})

export const exchangeUpdateRequested = ()=> ({
    type: EXCHANGE_UPDATE_REQUESTED
})
export const exchangeUpdateSucceeded = (payload) => ({
    type: EXCHANGE_UPDATE_SUCCEEDED,
    payload: payload
})
export const exchangeUpdateFailed = (err, res) => ({
    type: EXCHANGE_UPDATE_FAILED,
    error: err,
    response: res
})

export const exchangeUpdatesRequested = ()=> ({
    type: EXCHANGE_UPDATES_REQUESTED
})
export const exchangeUpdatesSucceeded = (payload) => ({
    type: EXCHANGE_UPDATES_SUCCEEDED,
    payload: payload
})
export const exchangeUpdatesFailed = (err, res) => ({
    type: EXCHANGE_UPDATES_FAILED,
    error: err,
    response: res
})



// WEBPACK FOOTER //
// ./src/model/Exchange/actions.js